module.exports = __webpack_public_path__ + "f5b11d54844ff4184f65fa97fc721aa7.png";